import { useRef, useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SidebarContext from '../context/SidebarContext';
import SearchTermContext from '../context/SearchTermContext';
import AuthContext from '../context/AuthProvider';
import ProfilePicture from '../static/img/profile.jpg';
import {NotificationsContext} from '../context/NotificationsContext';
import NotificationsPanel from './NotificationsPanel'

const Topbar = () => {
    const { collapsed } = useContext(SidebarContext);
    const { auth, logout } = useContext(AuthContext);
    const { setSearchTerm } = useContext(SearchTermContext);
    const { notifications } = useContext(NotificationsContext);
    const [searchType, setSearchType] = useState('orders');
    const navigate = useNavigate();
    const searchInputRef = useRef(null);
    const [showNotificationsPanel, setShowNotificationsPanel] = useState(false);


    const handleSearchSubmit = (e) => {
        e.preventDefault();
          setSearchTerm(searchInputRef.current.value);
          searchInputRef.current.value = '';
          if (searchType === 'orders'){
          navigate('/search');}
          if (searchType === 'books'){
            navigate('/products');}
      };
  
    return (
      <div className={`topbar ${collapsed ? 'collapsed' : ''}`}>
        <div className="top-right">
        <form className="search-container" onSubmit={handleSearchSubmit}>
          <input type="text" placeholder={`Search ${searchType}...`} ref={searchInputRef} />
          <button className="search-btn" type="submit">
            <i className="fa fa-search"></i>
          </button>
        </form>
        {searchType === 'orders' && <i className="fa fa-book" onClick={() => setSearchType('books')}></i>}
        {searchType === 'books' && <i className="fa fa-toolbox" onClick={() => setSearchType('orders')}></i>}
        </div>
        <div className="top-right">
          <p>
            {auth.firstName} {auth.lastName}
          </p>
          <img src={ProfilePicture} alt="" />
          <div className="icons">
          {showNotificationsPanel && <NotificationsPanel notifications={notifications} setShowNotificationsPanel={setShowNotificationsPanel}/>}
            <div onClick={() => setShowNotificationsPanel(!showNotificationsPanel)} className={(notifications && notifications.total > 0) ? "notification-icon" : undefined} data-count={notifications && notifications.total}>
              <i className="fas fa-bell"></i>
            </div>
            <div className="logout-icon">
              <Link to="/">
                <i className="fas fa-sign-out-alt" onClick={logout}></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  };  

export default Topbar;
